/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import { enableInitializing } from 'initializable-reducer';
import _ from 'lodash';

const initialState = {};

function studentIntelligenceHistory(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_STUDENT_INTELLIGENCE_HISTORY':
      if (responseHasError(payload)) {
        return state;
      }

      const { student_id, intelligence_id, group_by } = payload._meta.payload.request;

      const newHistory = {
        [student_id]: {
          [intelligence_id]: {
            [group_by]: payload.body
          }
        }
      };

      return _.merge({}, state, newHistory);
    default:
      return state;
  }
}

export {
  studentIntelligenceHistory,
  initialState
};

export default enableInitializing(studentIntelligenceHistory);
